/**
 * @file       Router module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

// Import vue and router
import Vue       from "vue";
import VueRouter from "vue-router";

// Import routes
import AuthRoutes     from "@/modules/auth/routes";
import TeachersRoutes from "@/modules/teachers/routes";
import StudentsRoutes from "@/modules/students/routes";
import AdminRoutes    from "@/modules/admin/routes";
import DelibRoutes    from "@/modules/deliberations/routes";

// Import components
import Home     from "../views/Home.vue";
import About    from "../views/About.vue";
import NotFound from "../views/NotFound.vue";

Vue.use(VueRouter);

/**
 * Routes.
 *
 * @type  {Object}
 */
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { layout: "basic" }
  },
  {
    path: "/about",
    name: "about",
    component: About,
    meta: { layout: "basic" }
  },
  ...AuthRoutes,
  ...TeachersRoutes,
  ...StudentsRoutes,
  ...AdminRoutes,
  ...DelibRoutes,
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
    meta: { layout: "basic" }
  }
];

/**
 * Router.
 *
 * @type  {Object}
 */
const router = new VueRouter({
  routes
});

// Default site title
const DEFAULT_TITLE = 'Dlibr: plateforme de délibération en ligne';
router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
